import { Icon } from "@/lib/ui";

export default function Pager({ skip, limit, total, onPage }) {
  const start = total === 0 ? 0 : skip + 1;
  const end = Math.min(skip + limit, total);
  const canPrev = skip > 0;
  const canNext = end < total;
  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <p className="text-sm text-muted-foreground" data-testid="pager-info">{start}–{end} of {total}</p>
      <div className="flex gap-2">
        <button data-testid="pager-prev" disabled={!canPrev} onClick={() => onPage(Math.max(0, skip - limit))}
          className="tap w-9 h-9 grid place-items-center rounded-full border border-border disabled:opacity-40 hover:bg-secondary">
          <Icon name="ChevronLeft" className="w-4 h-4" />
        </button>
        <button data-testid="pager-next" disabled={!canNext} onClick={() => onPage(skip + limit)}
          className="tap w-9 h-9 grid place-items-center rounded-full border border-border disabled:opacity-40 hover:bg-secondary">
          <Icon name="ChevronRight" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
